import styled from '@emotion/styled';
import { MEDIA_QUERY, FONT, COLORS } from '@zola/zola-ui/src/styles/emotion';
import backgroundMobile from '~/assets/images/preauth/weddingwebsite_listing_hero_mobile@1x.jpg';
import bgDesktop from '~/assets/images/preauth/WebsiteDesignPdpIntro_hero@2x.jpg';
import BulletedList from '@zola/zola-ui/src/components/PreAuth/BulletedList';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;

  height: 500px;
  padding: 30px 20px;
  background-image: url(${backgroundMobile});
  background-size: cover;
  background-position: left;

  ${MEDIA_QUERY.TABLET} {
    height: 400px;
    background-position: center;
    background-image: url(${bgDesktop});
  }
  ${MEDIA_QUERY.DESKTOP} {
    height: 400px;
    background-position: bottom;
    background-image: url(${bgDesktop});
  }
`;

export const Title = styled.h1`
  ${FONT.textSizeCompact(FONT.FONT_SIZE_LARGE)}
  color: ${COLORS.NAVY};
  font-family: ${FONT.FONT_FAMILY_SERIF};
  font-weight: ${FONT.FONT_WEIGHT_MEDIUM};

  ${MEDIA_QUERY.TABLET} {
    ${FONT.textSizeCompact(FONT.FONT_SIZE_LARGER)}
  }
  ${MEDIA_QUERY.DESKTOP} {
    ${FONT.textSizeCompact(FONT.FONT_SIZE_LARGER)}
  }
`;

export const Dek = styled.p`
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALL)};
  margin: 12px 30px 20px 30px;
  color: ${COLORS.BLACK};
`;

export const Br = styled.br`
  display: none;
  ${MEDIA_QUERY.DESKTOP} {
    display: initial;
  }
`;

export const StyledBulletedList = styled(BulletedList)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 8px;
  ${MEDIA_QUERY.DESKTOP} {
    flex-wrap: wrap;
    flex-direction: row;
    max-width: 580px;
  }
`;

export const Message = styled.li`
  display: flex;
  margin-bottom: 8px;
  color: ${COLORS.BLACK};
  flex-basis: 50%;
  width: 100%;
  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    flex-basis: 100%;
  }
  padding-right: 40px;
  ${FONT.textSizeUltraCompact(FONT.FONT_SIZE_SMALL)};
  &:before {
    top: 3px !important;
  }
`;
